import { QueryResources } from 'datx-jsonapi-react';

import { OmnisearchOccurrence } from '@/resources/OmnisearchOccurrence';
import { OmnisearchThinLecture } from '@/resources/OmnisearchThinLecture';

export const queryLecturePosterOccurrences = (
  lectureId: string,
  query: string
): QueryResources<OmnisearchOccurrence> => {
  if (!query || !lectureId) return null;
  return [
    `${OmnisearchThinLecture.type}/${lectureId}/occurrences`,
    {
      filter: {
        query,
        object_types: 'poster_document',
        context_size: 0,
      },
    },
  ];
};

export const queryLectureOmnisearchOccurrences = (
  lectureId: string,
  filters: Record<string, string>
): QueryResources<OmnisearchOccurrence> => {
  if (!filters?.query || !lectureId) return null;
  return [
    `${OmnisearchThinLecture.type}/${lectureId}/occurrences`,
    {
      filter: {
        context_size: 13,
        object_types: 'poster_document,transcript-en,slideshow,paper',
        ...filters,
      },
    },
  ];
};
